export default function timeFormat(isoString: string) {
    const date = new Date(isoString);
    const time = date.toLocaleTimeString('pl-PL');
    return {
        time: time
    };
}
